<template>
  <div class="tag-filter">
    <multiselect
      v-model="value"
      :placeholder="$tc('user.filter.usergroup')"
      label="name" track-by="name"
      :options="options"
      :searchable="false"
      @input="inputHandler"
      multiple
    >
      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <span class="option__title">{{ props.option.name }}</span>
        </div>
      </template>
    </multiselect>
<!--    <multiselect-->
<!--      v-model="value"-->
<!--      :placeholder="$tc('user.filter.consumer')"-->
<!--      label="name" track-by="name"-->
<!--      :options="optionsEditorConsumers"-->
<!--      :searchable="false"-->
<!--      @input="inputHandler"-->
<!--      multiple-->
<!--    >-->
<!--      <template slot="option" slot-scope="props">-->
<!--        <div class="option__desc">-->
<!--          <span class="option__title">{{ props.option.name }}</span>-->
<!--        </div>-->
<!--      </template>-->
<!--    </multiselect>-->

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import debounce from 'lodash.debounce'
import {refreshGroups} from '@/store'
export default {
  components: {
    Multiselect
  },
  mounted () {
    if (!this.options) {
      refreshGroups(this.$store)
    }
  },

  data: () => ({
    value: []
  }),
  methods: {
    inputHandler: debounce(function () {
      const filterOptions = this.value.map(option => option.slug)
      this.$emit('change', filterOptions)
    }, 350)
  },
  computed: {
    options () {
      if (this.$store.state.groups) {
        return this.$store.state.groups
      }
      return []
    },
    optionsEditorConsumers () {
      if (this.$store.state.editorConsumers) {
        return this.$store.state.editorConsumers
      }
      return []
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

